/* eslint-disable no-underscore-dangle */
import { Modal, Progress, Tooltip } from 'antd';
import { ResultGetModel } from 'data/result/result.model';
import React from 'react';
import { Student } from './ResultView';

const TableColumn = () => {
  return [
    {
      name: 'Student Name',
      selector: 'student',

      cell: (row: Student) => (
        <div>
          <div>{row.student}</div>
        </div>
      ),
    },
    {
      name: 'Percentage ',
      selector: 'percentage',

      cell: (row: Student) => (
        <div>
          <div>{row.percentage}%</div>
        </div>
      ),
    },
    {
      name: 'Status ',

      cell: (row: Student) => (
        <div>
          <div style={{ width: 170 }}>
            <Tooltip
              placement="left"
              title={`${
                row.subjects === row.totalSubjects
                  ? `All subject's mark has been added.`
                  : `${row.subjects} out of
              ${row.totalSubjects} subject marks have been added.`
              }`}
            >
              <Progress
                percent={row.status}
                format={() => `${row.subjects}/${row.totalSubjects} Subjects`}
                size="small"
              />
            </Tooltip>
          </div>
        </div>
      ),
    },
    // ...Array.from({ length: getDaysInMonth(month, year) }, (_, i) => i + 1).map((item) => {
    //   const day = dateFormater(`${item}`);
    //   return {
    //     name: day,
    //     selector: day,
    //     width: '40px',
    //     //   sortable: true,
    //     cell: (row: any) => {
    //       return (
    //         <div>
    //           <div>{getAttendanceStatus(row.__attendances__, day)}</div>
    //         </div>
    //       );
    //     },
    //   };
    // }),
  ];
};

export default TableColumn;
